<template>
    <div>同意企业服务免责协议</div>
</template>

<script>
    export default {
        name: "updateAgreement"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/updateAgreement.vue